import { useCallback, useEffect, useState } from 'react';
const SOUND_KEY = 'lato.comments.sound.v1';
const SOUND_EVENT = 'lato-comment-sound-change';
let sharedAudio: AudioContext | null = null;
const preference = () => { try { return localStorage.getItem(SOUND_KEY) === 'on'; } catch { return false; } };
function prepare() {
  const Audio = window.AudioContext || (window as any).webkitAudioContext;
  if (!Audio) return null;
  if (!sharedAudio || sharedAudio.state === 'closed') {
    sharedAudio = new Audio();
    const audio = sharedAudio;
    window.addEventListener('pagehide', () => { void audio?.close().catch(() => {}); if (sharedAudio === audio) sharedAudio = null; }, { once: true });
  }
  void sharedAudio?.resume().catch(() => {});
  return sharedAudio;
}
/** One opt-in sound preference and one audio context across drawer/background updates. */
export function useCommentSound() {
  const [enabled, setEnabled] = useState(preference);
  useEffect(() => {
    const sync = () => setEnabled(preference());
    window.addEventListener(SOUND_EVENT, sync); window.addEventListener('storage', sync);
    return () => { window.removeEventListener(SOUND_EVENT, sync); window.removeEventListener('storage', sync); };
  }, []);
  const play = useCallback(() => {
    if (!preference() || document.hidden) return;
    try {
      const audio = prepare(); if (!audio || audio.state !== 'running') return;
      const gain = audio.createGain(); const oscillator = audio.createOscillator();
      gain.gain.setValueAtTime(0.0001, audio.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.035, audio.currentTime + 0.015);
      gain.gain.exponentialRampToValueAtTime(0.0001, audio.currentTime + 0.22);
      oscillator.frequency.setValueAtTime(740, audio.currentTime);
      oscillator.frequency.exponentialRampToValueAtTime(560, audio.currentTime + 0.2);
      oscillator.connect(gain); gain.connect(audio.destination); oscillator.start(); oscillator.stop(audio.currentTime + 0.24);
      oscillator.onended = () => { oscillator.disconnect(); gain.disconnect(); };
    } catch { /* Audio permission is optional; comments still work. */ }
  }, []);
  const toggle = () => {
    const next = !preference(); if (next) prepare();
    try { localStorage.setItem(SOUND_KEY, next ? 'on' : 'off'); } catch { /* Privacy mode. */ }
    setEnabled(next); window.dispatchEvent(new Event(SOUND_EVENT));
  };
  return { enabled, toggle, play };
}
